import type { FlowV2_Action__Input } from '~/graphql/types';
import type { ClientFlowActionWait } from '~/graphql/types.client';
import generateConditionList from '~/components/page/Automation/v2/components/UpdateAction/components/ConditionEditorV2/utils/generateConditionList';

/**
 *
 * @param {ClientFlowActionWait} action - Wait client action
 * keywords:
 */
const serializeWaitAction = (
  action: ClientFlowActionWait,
): FlowV2_Action__Input => {
  const { id, accountId, parentIds, flowBlueprintId, condition } = action;

  return {
    Wait: {
      id,
      accountId,
      flowBlueprintId,
      parentIds,
      condition: generateConditionList(condition),
    },
  };
};

export default serializeWaitAction;
